import { Formik, FormikHelpers } from "formik"
import { DirtyFormPrompt } from "../form/DirtyFormPrompt"
import { ControlcenterMelcoModelsThreadChart, UseApiQueryKey, useFormSubmit } from "melco-shared-logic"
import { useQueryClient } from "react-query"
import { useEditThread } from "../../hooks/threads/useEditThread"
import { usePublishThread } from "../../hooks/threads/usePublishThread"
import { DisplayUpdateThreadForm } from "./DisplayUpdateThreadForm"

type UpdateThreadFormProps = {
    thread: ControlcenterMelcoModelsThreadChart;
    refetch: any;
    queryKey: UseApiQueryKey
}


export const UpdateThreadForm: React.FC<UpdateThreadFormProps> = ({ queryKey, refetch, thread }) => {
    const queryClient = useQueryClient()

    //const [initialValues] = useState(thread);
    const editThread = useEditThread();
    const publishThread = usePublishThread();



    const onSubmit = async (values: any, formikHelpers: FormikHelpers<any>) => {

        const { submitAction } = values;
        console.log(submitAction)
        if (submitAction === "save")
            await onUpdateThread(values, formikHelpers, { isManuallyResettingForm: true });
        else
            await onPublishThread(values, formikHelpers, { isManuallyResettingForm: true })
    }

    const handleSaveAndPublish = async (values: any, formikHelpers: FormikHelpers<any>, options: any) => {
        const { publish } = options;
        // console.log(publish == true ? "true" : "false")
        let newEntity = await editThread({ ...values })
        if (publish) {
            // publish
            newEntity = await publishThread(
                values.id
            )

        }

        // // update UI with new Data
        // formikHelpers.resetForm({
        //     values: newEntity ?? thread
        // })

        formikHelpers.setValues(newEntity ?? thread);

        queryClient.setQueryData(queryKey, newEntity)
        return {
            successMessages: [
                {
                    message: "default"
                }
            ]
        }
    }

    const formSubmitWithPublish = (publish: boolean) => {

        return [
            async (values: any, formikHelpers: FormikHelpers<any>) => {

                return handleSaveAndPublish(values, formikHelpers, { publish })
            }, {
                translationPrefix: ['managethreads.actions', publish ? 'publish' : 'save'].join("."),
                onError: () => {
                    queryClient.invalidateQueries("editthread")
                }
            }] as const;
    }

    const onUpdateThread = useFormSubmit(...formSubmitWithPublish(false));
    const onPublishThread = useFormSubmit(...formSubmitWithPublish(true));


    return (<>
        {thread && <Formik<ControlcenterMelcoModelsThreadChart>
            initialValues={thread}
            onSubmit={onSubmit}
            enableReinitialize={true}

        >

            <DirtyFormPrompt>

                <DisplayUpdateThreadForm thread={thread} refetch={refetch} />
            </DirtyFormPrompt>
        </Formik >
        }
    </>)
}